import React from 'react';
import { useLocation, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import SubHeader from 'components/SubHeader';
import FooterBar from 'components/FooterBar';
import SettingsNav from './components/SettingsNav';
import RatePlan from './components/RatePlan';
import CouponCode from './components/CouponCode';
import HotelInfoAndPolicies from './components/HotelInfoAndPolicies';
import { Content, Container, NavContainer } from './styles';

const Settings = () => {

  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <>
      <Helmet>
        <title>Settings - Rook Hotel PMS</title>
        <meta name="description" content="Settings - Rook Hotel PMS" />
      </Helmet>
      <SubHeader>
        <div className='title'>
          <a
            className='highlight'
            href='https://pms.rookhotel.com/settings'
            rel='noopener noreferrer'
            onClick={(event) => {
              // Handle special key combinations (Ctrl/Cmd+click)
              if (event.metaKey || event.ctrlKey) {
                // Allow default behavior (opens in new tab)
                return;
              }
              
              // Prevent default anchor behavior (full page reload)
              event.preventDefault();
              
              // Perform client-side navigation
              navigate('/settings');
            }}
          >
            Settings
          </a> 
          {(pathname.split('/')[2])? (' > ' + pathname.split('/')[2]): ''}
        </div>
      </SubHeader>
      <Content>
        <NavContainer>
          <SettingsNav />
        </NavContainer>
        <Container>
          <Routes>
            <Route
              path={'/'}
              element={<>Settings Dashboard</>}
            />
            <Route
              path={'rate-plan'}
              element={<RatePlan />}
            />
            <Route
              path={'coupon-code'}
              element={<CouponCode />}
            />
            <Route
              path={'room-type-configuration'}
              element={<RatePlan />}
            />
            <Route
              path={'room-configuration'}
              element={<RatePlan />}
            />
            <Route
              path={'hotel-charges'}
              element={<RatePlan />}
            />
            <Route
              path={'hotel-info-and-policies'}
              element={<HotelInfoAndPolicies />}
            />
            <Route path="*" element={<Navigate to="/settings" replace />} />
          </Routes>
        </Container>
      </Content>
      <FooterBar />
    </>
  );
};

export default Settings;